/**
 * Contrato de resposta padrão da nest-end-customer-api (TransformInterceptor
 * global). Fonte única do tipo — antes estava declarado 3× (http client, BFF
 * e proxy).
 */
export interface NestEnvelope<T = unknown> {
    success: boolean;
    data?: T;
    error?: {
        statusCode: number;
        message: string | string[];
        /**
         * Em produção só carrega um conjunto fixo de chaves (errors,
         * problematicProducts, unavailableProducts, errorCode, errorType,
         * canRetry, suggestions, failedAttempts, remainingAttempts, isBlocked,
         * blockExpiresAt, retryAfterSeconds). O resto é descartado lá.
         */
        details?: Record<string, unknown>;
    };
    timestamp?: string;
    path?: string;
}

/** true se o corpo tem o formato de envelope da nest. */
export function isNestEnvelope(body: unknown): body is NestEnvelope {
    return !!body && typeof body === "object" && "success" in body;
}
